import { render, staticRenderFns } from "./TempSpuShopPoisField.vue?vue&type=template&id=48423e64"
import script from "./TempSpuShopPoisField.vue?vue&type=script&lang=ts"
export * from "./TempSpuShopPoisField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports